import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionAuthoritiesPhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`authoritiesPhotos-${sessionId}`, [])
);

export const authoritiesPhotosAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionAuthoritiesPhotosAtom);
